import { urlQueryString } from '@azgaz/azgaz-ui/connect/lib/utils';

// удаляет из url qury параметр office так как это поле не завязано на фильтр
// и оно не удаляется автоматически при сбросе фильров или обновлении страницы
const removeOfficeFromUrl = () => {
  const { offices, ...withoutOffices } = urlQueryString.get();
  urlQueryString.set(withoutOffices);
};

export default removeOfficeFromUrl;
